export const STATUS_CLASSES = {
  scheduled: 'bg-n-blue-3 border-n-blue-6 text-n-blue-11',
  done: 'bg-n-teal-3 border-n-teal-6 text-n-teal-11',
  no_show: 'bg-n-ruby-3 border-n-ruby-6 text-n-ruby-11',
  rescheduled: 'bg-n-amber-3 border-n-amber-6 text-n-amber-11',
  cancelled: 'bg-n-slate-3 border-n-slate-6 text-n-slate-11',
};

export const STATUS_LABEL_KEYS = {
  scheduled: 'SCHEDULED',
  done: 'DONE',
  no_show: 'NO_SHOW',
  rescheduled: 'RESCHEDULED',
  cancelled: 'CANCELLED',
};

export const STATUS_ORDER = [
  'scheduled',
  'done',
  'no_show',
  'rescheduled',
  'cancelled',
];

const STATUS_OPACITY = {
  scheduled: '',
  done: 'opacity-60',
  no_show: 'opacity-60',
  rescheduled: '',
  cancelled: 'opacity-50',
};

const PAST_MEETING_OPACITY_CLASS = 'opacity-50';

const STATUS_BAR_CLASSES = {
  scheduled: 'bg-n-blue-9',
  done: 'bg-n-teal-9',
  no_show: 'bg-n-ruby-9',
  rescheduled: 'bg-n-amber-9',
  cancelled: 'bg-n-slate-9',
};

export function statusClass(status) {
  return STATUS_CLASSES[status] ?? STATUS_CLASSES.scheduled;
}

export function statusBarClass(status) {
  return STATUS_BAR_CLASSES[status] ?? STATUS_BAR_CLASSES.scheduled;
}

export function statusOpacityClass(status) {
  return STATUS_OPACITY[status] ?? '';
}

export function isPastMeeting(meeting) {
  if (!meeting?.end_at) return false;
  return new Date(meeting.end_at).getTime() < Date.now();
}

export function meetingOpacityClass(meeting) {
  const statusOpacity = STATUS_OPACITY[meeting?.status] ?? '';
  if (!isPastMeeting(meeting)) return statusOpacity;
  return statusOpacity || PAST_MEETING_OPACITY_CLASS;
}

export function statusLabelKey(status) {
  return STATUS_LABEL_KEYS[status] ?? status;
}

export function isKnownStatus(status) {
  return Object.prototype.hasOwnProperty.call(STATUS_LABEL_KEYS, status);
}
